import { InferSelectModel } from 'drizzle-orm';
import { index, pgTable, serial, timestamp } from 'drizzle-orm/pg-core';

import { createPubkeyField } from './utils';

export const account_deletion_requests = pgTable(
	'account_deletion_requests',
	{
		id: serial('id').primaryKey(),

		authority: createPubkeyField('authority').notNull(),

		requestedAt: timestamp('requestedAt', { withTimezone: true })
			.notNull()
			.defaultNow(),
	},
	(t) => {
		return {
			authorityIdx: index('account_deletion_requests_authority_idx').on(
				t.authority
			),
			requestedAtIdx: index('account_deletion_requests_requestedAt_idx').on(
				t.requestedAt
			),
		};
	}
);

export type AccountDeletionRequest = InferSelectModel<
	typeof account_deletion_requests
>;
